export default __webpack_public_path__ + "static/media/grusha_card.bf676f40.png";